import constantURL from "./ConstantURL";
import { getDataAPI } from "./index";

const normalizeApiResponse = (response, fallbackMessage) => {
  if (!response) {
    return { success: false, message: fallbackMessage, data: null };
  }

  if (response.status === "success") {
    return {
      success: true,
      message: response.message || "Success.",
      data: response.data ?? null,
    };
  }

  return {
    success: false,
    message: response.message || fallbackMessage,
    data: null,
  };
};

export const getVitalsOfFamilyMember = async (clientId) => {
  if (!clientId) {
    return { success: false, message: "Client is not selected.", data: [] };
  }

  try {
    const response = await getDataAPI(`${constantURL.getVitalsOfFamilyMember}?clientId=${clientId}`);
    const result = normalizeApiResponse(response, "Failed to fetch vitals.");
    if (!result.success) {
      return { ...result, data: [] };
    }
    return { ...result, data: Array.isArray(result.data) ? result.data : [] };
  } catch {
    return { success: false, message: "Unable to reach the server. Please try again.", data: [] };
  }
};

export const getCheckListOfFamilyMember = async (clientId, date) => {
  if (!clientId) {
    return { success: false, message: "Client is not selected.", data: null };
  }

  if (!date) {
    return { success: false, message: "Date is required.", data: null };
  }

  try {
    const response = await getDataAPI(`${constantURL.getCheckListOfFamilyMember}?clientId=${clientId}&date=${date}`);
    return normalizeApiResponse(response, "Failed to fetch checklist.");
  } catch {
    return { success: false, message: "Unable to reach the server. Please try again.", data: null };
  }
};
